module.exports = __webpack_public_path__ + "media/images/icons/outlined/fund-view-489d728a3f141bac8c24dde22861ea76.svg";